import styled from 'styled-components'
import media from 'src/styles/media'

export const PaginationWrapper = styled.nav`
    color: black;
    margin-top: 50px;
    
    ${media.lessThan('md')`
        margin-top: 30px;
    `}

    .ais-Pagination-list{
        display: flex;
        justify-content: center;
        list-style: none;
        margin: 0;
        padding: 0;

        .ais-Pagination-item{
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 5px;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background-color: transparent;
            transition: all 0.4s;
            color: var(--navy);
            font-size: 17px;

            &:hover{
                transform: scale(1.05);
            }

            &--selected{
                color: #fff;
                background-color: var(--primary);
            }

            ${media.lessThan('md')`
                width: 30px;
                height: 30px;
                font-size: 15px;
            `}
        }

        .ais-Pagination-link{
            color: inherit !important;
            text-decoration: none;
        }
    }
    `